
<template>

    <div :class="[ToggleState]">

 
        <table class="ListTable" ref="ListTable" :class="{'PreparingColumns':Preparing==true ,
               'Empty':(Preparing != true && m_Rows != null && m_Rows.length == 0)
               }">
            <tr class="Header" v-if="ShowHeader != 'false' && ShowHeader != false">

                <td v-for="column in m_Columns"
                    class="CaptionContainer"
                    :ColumnName="column.ColumnName"
                    @click="OnColumnHeaderClick(column.ColumnName)"
                    :style="column.HeaderStyle"
                    :class="[column.HeaderClassName]">

                    <template v-if="HeaderTextSlot != null">

                        <slot name="HeaderText"
                              :HeaderText="column.HeaderText"></slot>

                    </template>
                    <template v-else>
                        <span v-html="column.HeaderText"></span>
                    </template>

                    <template v-if="SortByColumn != '' && SortByColumn==column.ColumnName">
                        <template v-if="Scending == 'ASC'">
                            ▴
                        </template>
                        <template v-else="Scending == 'ASC'">
                            ▾
                        </template>
                    </template>
                </td>

            </tr>
            <tr v-for="(row,index) in m_Rows" class="Row"
                :class="{'Active' : row == SelectedRow}"
                @click="(e)=>{OnRowClick(row,e);}">
                <template v-if="RowSlot != null">
                    <slot name="Row"
                          :row="row"
                          :index="index"></slot>

                </template>
                <template v-else>

                    <template v-for="column in m_Columns">
                        <td>

                            <slot :name="column.ColumnName"
                                  :Row="row"></slot>
                        </td>
                    </template>
                </template>

            </tr>

            <tr v-if="m_Rows != null && m_Rows.length == 0">
                <td :colspan="10" style="line-height:40px;white-space:normal;">

                    <div v-if="EmptyText != null">
                        {{EmptyText}}
                    </div>
                    <div v-else>
                        沒有資料
                    </div>
                </td>
            </tr>
        </table>

        <div v-if="ToggleState=='Collapsed' && m_Rows != null && m_Rows.length>10"
             class="DotLine">
            ...
        </div>
        <div class="ToggleButtonContainer"
             v-if="m_Rows != null && m_Rows.length>10">
            <t-button class="Button Toggle Expand" style="width:100%"
                      @click="()=>{ToggleState='Expanded'}"
                      title="展開"> ▼</t-button>
            <t-button class="Button Toggle Collapse" style="width:100%"
                      @click="()=>{ToggleState='Collapsed'}"
                      title="收起"> ▲ </t-button>
        </div>

        <paging :PagingData="m_PagingData"
                :key="Key"
                v-if="ShowPaging != 'false' && ShowPaging != false"
                v-on:change="OnPagingDataChange" />


         
    </div>



</template>

<script scoped>
    import Utility from '@/Common/Utility';
    import apiService from '@/Common/ApiService';
    import PlugableControlBase from "@/Common/PlugableControlBase";
    import eventBus from '@/Common/EventBus';


    export default {
        name: "ListView",
        data() {
            return {
                m_Columns: [],
                RowSlot: null,
                HeaderTextSlot: null,
                SortByColumn: "",
                Scending: "ASC",
                ToggleState: "NONE",
                Preparing: false,

                SelectedRow: null,
                m_QueryHandler: null,

                ATime: null,
                BTime: null,
                CTime : null,

                CheckedRowsDic: {},

                m_CheckedRows: [],

                m_Rows: [
                    {
                        Checked:false
                    }
                ],

                Key: 1,

                m_PagingData: {
                    RecordPerPage: 10,
                    TotalCount: 1000,
                    CurrentPageNumber: 1,
                },

            }
        }
        ,

        //無法使用 TControlBase
        props: ["Rows", "Columns", "PagingData", "OrderBy", "Name",
            "RecordPerPage", "QueryHandler", "ShowHeader", "ShowPaging", "EnableToggle", "EmptyText", "KeepChecked",
        ],

        methods: {

            SetCTime() {
                this.CTime = new Date();
            },

            OnCheckboxChange(e) {
                let checkedRows = [];

                this.StoreCheckedRows();

                for (let key in this.CheckedRowsDic) { 
                    let checkedRow;

                    checkedRow = this.CheckedRowsDic[key];

                    checkedRows.push(checkedRow);
                }

                this.$emit("CheckedRowsChange", checkedRows);
            },

            QueryList() {
                this.CheckedRowsDic = {};
                this.m_CheckedRows.length = 0;
                this.m_PagingData.CurrentPageNumber = 1;

                return this._QueryList();
            },

            LoadRows(rows) {
                let i;

                if (rows != null) {
                    this.m_Rows = rows;
                }
                else {
                    this.m_Rows.length = 0;
                }

                for (i = 0; i < this.m_Rows.length; i++) {
                    this.m_Rows[i].__RowIndex = i;
                }
                 


                //PROBLEM
                this.$emit("change", this.m_Rows);
                this.$emit("load", this.m_Rows);

                if (this.m_Rows.length > 0) {
                    this.PrepareColumns();
                }
                else {
                    
                    this.PrepareColumnsWithNoRows();
                }

            },

            _QueryList() {
                let resolveHadler = null;
                let m_QueryHandlerResultPromise;
                let resultPromise = new Promise(
                    (resv) => {
                        resolveHadler = resv;
                    }
                );

                if (this.m_QueryHandler != null) {


                    Utility.ShowLoadingPicture();

                    m_QueryHandlerResultPromise = this.m_QueryHandler(this.m_PagingData, this.OrderBy);


                    if (m_QueryHandlerResultPromise == null) {
                        Utility.HideLoadingPicture();

                        this.m_Rows = [];
                        this.m_PagingData.CurrentPageNumber = 1;
                        this.m_PagingData.TotalCount = 0;

                        this.Key++;

                        this.PrepareColumnsWithNoRows();

                        this.$forceUpdate();


                        this.$emit("change", this.m_Rows);
                        this.$emit("load", this.m_Rows);

                        return;
                    }

                    this.ATime = new Date();


                    m_QueryHandlerResultPromise.then(
                        function (responseData) {
                            let i;

                            this.BTime = new Date();


                            Utility.HideLoadingPicture();

                            if (responseData == null) {
                                this.m_Rows = [];
                                this.$forceUpdate();

                                this.$emit("change", this.m_Rows);
                                return;
                            }


                            if (Array.isArray(responseData)) {
                                this.m_Rows = responseData;
                            }
                            else if (responseData.Rows != undefined && responseData.Rows != null) {
                                this.m_Rows = responseData.Rows;
                            }
                            if (responseData.Rows2 != undefined && responseData.Rows2 != null) {
                                this.m_Rows = responseData.Rows2;
                            }
                            if (responseData.Rows3 != undefined && responseData.Rows3 != null) {
                                this.m_Rows = responseData.Rows3;
                            }
                            if (responseData.Rows4 != undefined && responseData.Rows4 != null) {
                                this.m_Rows = responseData.Rows4;
                            }


                            for (i = 0; i < this.m_Rows.length; i++) {
                                if (this.m_Rows[i] != null) {
                                    this.m_Rows[i]["__RowIndex"] = i;
                                }
                            }

                            if (responseData.Paging != null) {
                                this.m_PagingData = responseData.Paging;
                            }
 
                            //Utility.LoadListViewResponse(this.$parent, responseData);

                            if (this.KeepChecked == true || this.KeepChecked == "true") {
                                let key;

                                for (i = 0; i < this.m_Rows.length; i++) {
                                    key = this.GetRowKey(this.m_Rows[i]);

                                    if (this.CheckedRowsDic[key] != null) {
                                        this.m_Rows[i].Checked = true;
                                        this.$forceUpdate();
                                    }
                                    else {
                                        this.m_Rows[i].Checked = false;
                                    }
                                }
                            }

                            setTimeout(
                                function () {
                                    if (this.m_Rows.length > 0) {
                                        this.PrepareColumns();
                                    }
                                    else {
                                        this.PrepareColumnsWithNoRows();
                                    }

                                    Utility.HideLoadingPicture();

                                }.bind(this),
                                30
                            );

                            resolveHadler(responseData);
                            this.$emit("after", responseData);
                            this.$emit("change", this.m_Rows);
                            this.$emit("load", this.m_Rows);

                        }.bind(this)
                    );
                }
                else {
                    setTimeout(
                        () => {
                            resolveHadler();

                            this.$emit("change", this.m_Rows);
                            this.$emit("load", this.m_Rows);
                        },
                        100
                    );
                }

                return resultPromise;
            },

            GetRowKey(row) {
                let valueSetRow = null;
                let propertyName;
                let count = 0;
                let key = "";


                if (row.ValueSet != null) {
                    valueSetRow = row.ValueSet;
                }
                else {
                    valueSetRow = row;
                }

                for (propertyName in valueSetRow) {
 
                    if (
                        propertyName != "Checked" &&
                        propertyName != "SeqNo" &&
                        propertyName.indexOf("Time") < 0 && propertyName.indexOf("Date") < 0
                        &&
                        typeof (valueSetRow[propertyName]) != "object"
                    ) {
                        key += propertyName + ":" + valueSetRow[propertyName];

                        key += "_";

                        count++;

                        if (count > 10) {
                            break;
                        }
                    }
                }

                return key;
            },

            StoreCheckedRows() {
                let key;
                let i;

                 
                for (i = 0; i < this.m_Rows.length; i++) {
                    key = this.GetRowKey(this.m_Rows[i]);

                    if (this.m_Rows[i].Checked == true) {
                        this.CheckedRowsDic[key] = this.m_Rows[i];
                    }
                    else {
                        delete this.CheckedRowsDic[key];
                    }
                }
            },

            OnPagingDataChange(pagingData) {

                if (this.KeepChecked == true || this.KeepChecked == "true") {
                    this.StoreCheckedRows();
                }
 
                this.m_PagingData = pagingData;
                this.$emit("PagingDataChange", this.m_PagingData);
                this._QueryList();
            },

            OnColumnHeaderClick(columnName) {

                if (columnName != null && columnName != "") {

                    this.SortByColumn = columnName;

                    if (this.Scending == "ASC") {
                        this.Scending = "DESC"
                    }
                    else {
                        this.Scending = "ASC"
                    }


                    this.m_PagingData.OrderBy = this.SortByColumn + " " + this.Scending;

                    this.m_PagingData.CurrentPageNumber = 1;
                    this.OrderBy = this.SortByColumn + " " + this.Scending;
                    this.$emit("OrderByChange", this.OrderBy);

                    this._QueryList();

                }
            },

            OnRowClick(row,e) {
                
                this.SelectedRow = row;
                this.$emit("RowClick", row,e);
            },

            PrepareColumnsWithNoRows() {
                if (this.m_Rows == null) {
                    this.m_Rows = [];
                }

                this.Preparing = true;
                //console.log("PrepareColumnsWithNoRows")

                this.m_Rows.push(
                    {
                        ValueSet: {

                        }
                    }
                );
                this.$forceUpdate();

                setTimeout(
                    () => {
                        this.Preparing = false;
                    },
                    100
                );


                setTimeout(
                    function () {
                        this.PrepareColumns();
                        this.m_Rows.length = 0;


                        this.$emit("change", this.m_Rows);
                        this.$forceUpdate();

                    }.bind(this),
                    10
                );
            },

            PrepareColumns() {
                let listTableElement;
                let i;

 
       

                listTableElement = this.$refs.ListTable;

                //this.m_Columns.length = 0;


                if (this.$refs.ListTable == null) {
                    return;
                }

                if (this.$refs.ListTable.rows.length >= 2) {
                    for (i = 0; i < this.$refs.ListTable.rows[1].cells.length; i++) {
                        let tdElement;
                        let headerText;
                        let columnName;
                        let headerStyle;
                        let headerClassName;


                        tdElement = listTableElement.rows[1].cells[i];
                        headerText = tdElement.getAttribute("HeaderText");

                        if (headerText != null && headerText.indexOf("_br_") >= 0) {
                            headerText = headerText.replace("_br_", "<br />");
                        }
 
                        columnName = tdElement.getAttribute("ColumnName");
                        headerStyle = tdElement.getAttribute("HeaderStyle");
                        headerClassName = tdElement.getAttribute("HeaderClassName");


                        if (this.m_Columns.length <= i) {
                            this.m_Columns.push({
                                HeaderText: "",
                                ColumnName: ""
                            }
                            );
                        }


                        this.m_Columns[i].HeaderText = headerText;

                        if (columnName != null) {
                            this.m_Columns[i].ColumnName = columnName;
                        }

                        if (headerStyle != null) {
                            this.m_Columns[i].HeaderStyle = headerStyle;
                        }

                        if (headerClassName != null) {
                            this.m_Columns[i].HeaderClassName = headerClassName;
                        }
                    }

                    this.$forceUpdate();

                } else {
                    if (this.$refs.ListTable.rows.length < 2) {
                        setTimeout(
                            function () {
                                this.PrepareColumns();
                            }.bind(this),
                            1000
                        );
                    }
                }

            },



            ResetColumns() {
                for (let columnName in this.$scopedSlots) {
                    if (columnName == "Row" || columnName == "row") {
                        this.RowSlot = this.$scopedSlots[columnName];

                        if (this.Rows != null && this.Rows.length == 0) {
                            this.PrepareColumnsWithNoRows();
                        }
                        else {
                            setTimeout(
                                function () {
                                    this.PrepareColumns();
                                }.bind(this),
                                10
                            );
                        }
                    }
                    else if (columnName == "HeaderText") {
                        this.HeaderTextSlot = this.$scopedSlots[columnName];
                    }
                }

            },

            OnCheckedChange(newVal) {
            },

        },

        beforeMount() {
        },

        created: function () {

            this.m_Rows = [];
            
            if (this.Rows != null) {
                this.m_Rows = this.Rows;
            }
             
            this.m_QueryHandler = this.QueryHandler;

            this.RowSlot = null;


            if (this.PagingData != null) {
                this.m_PagingData = this.PagingData;
            }

            if (this.RecordPerPage != null) {
                this.m_PagingData.RecordPerPage = parseInt(this.RecordPerPage + "");
            }
        },


        mounted: function () {
            let vnodes;
            let i;

            if (this.Rows != null) {
                this.m_Rows = this.Rows;
            }
            else {
                this.m_Rows.length = 0;
            }

            this.m_Columns = [];



            for (let columnName in this.$scopedSlots) {
                if (columnName == "Row" || columnName == "row") {
                    this.RowSlot = this.$scopedSlots[columnName];



                    if (this.Rows == null) {
                        if (this.QueryHandler == null) {
                            this.m_Rows = [];
                            this.PrepareColumnsWithNoRows();
                        }
                    }
                    else if (this.Rows != null && this.Rows.length == 0) {
                        if (this.QueryHandler == null) {
                            this.PrepareColumnsWithNoRows();
                        }
                    }
                    else {
                        setTimeout(
                            function () {
                                this.PrepareColumns();
                            }.bind(this),
                            10
                        );
                    }
                }
                else if (columnName == "HeaderText") {
                    this.HeaderTextSlot = this.$scopedSlots[columnName];
                }
            }
             
            this._QueryList();


            if (this.EnableToggle == true || this.EnableToggle == "true") {
                this.ToggleState = "Collapsed";
            }
            else {
                this.ToggleState = "NONE";
            }

        },

        beforeMounted() {

        },

        beforeDestroy() {
            this.Destroyed = true;
            this.KeepConnectionRunning = false;
        },

        components: {
        },


        computed: {

            CheckedRows: {
                get() {
                    let checkedRows = [];

                    this.StoreCheckedRows();

                    for (let key in this.CheckedRowsDic) {
                        let checkedRow;

                        checkedRow = this.CheckedRowsDic[key];

                        checkedRows.push(checkedRow);
                    }
 
                    return checkedRows;
                } ,
            },

            FinalRows: {
                get() {
                    return this.m_Rows;
                }
            }
        },

        watch: { 
             
            Rows(newVal) {


                this.m_Rows = newVal;

                this.$forceUpdate();

                if (this.m_Rows.length > 0) {
                    //Utility.DelayExecute(
                    //    () => {
                    //        this.PrepareColumns();
                    //    },
                    //    "OnNewRows",
                    //    this
                    //);
                }
                else {
                    //this.PrepareColumnsWithNoRows();
                }

            },

            PagingData(newVal) {

                if (newVal != null) {
                    this.m_PagingData = newVal;
                    this.$forceUpdate();
                }
            },

            '$route'(to, from) {

                // Put your logic here...
            }

        },

        beforeRouteLeave(to, from, next) {

            next();
        }


    }
</script>

<style>
    .Chat .ButtonList .Button {
        margin-bottom: 5px;
    }

    @media screen and (max-width:660px) {
        .Chat .ButtonList .Button {
            padding-left: 2px;
            padding-right: 2px;
        }
    }
</style>
<style scoped>



    .ListTable > tr.Header > td:not([ColumnName='']) {
        cursor: pointer;
    }



    .ListTable.PreparingColumns > tr.Row td {
        opacity: 0;
        border-color: transparent;
    }

    .Button.Toggle {
        background-color: white;
        color: #666666;
        font-size: 20px;
        padding-left: 0px;
        padding-right: 0px;
        border: 1px solid #e0e0e0;
    }

    .NONE .ToggleButtonContainer {
        display: none;
    }

    .Collapsed .Button.Toggle.Collapse {
        display: none;
    }

    .Collapsed .Button.Toggle.Expand {
        display: block;
    }

    .Expanded .Button.Toggle.Collapse {
        display: block;
    }

    .Expanded .Button.Toggle.Expand {
        display: none;
    }


    .DotLine {
        font-size: 30px;
        display: block;
        width: 100%;
        text-align: center;
        position: relative;
        top: -20px;
    }


    .NONE .DotLine,
    .Expanded .DotLine {
        display: none;
    }

    .Collapsed .ListTable > tr.Row:nth-child(n+12) {
        display: none;
    }
</style>
